// extracted by mini-css-extract-plugin
module.exports = {"container":"TextBannerScreen_container__3nBP3","heading":"TextBannerScreen_heading__dArb5","headingText":"TextBannerScreen_headingText__2D6h2"};